/**
 * Chat API - Interact with Hub's AI chat system
 * @module ChatAPI
 */

export class ChatAPI {
  /**
   * Send a message to the chat system
   * @param {string} message - Message to send
   * @param {object} options - Optional parameters
   * @returns {Promise<object>} Chat response
   */
  async send(message, options = {}) {
    try {
      const response = await fetch('/api/chat/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          message,
          ...options
        })
      });
      
      if (!response.ok) {
        throw new Error(`Chat request failed: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('[ChatAPI] Error sending message:', error);
      throw error;
    }
  }

  /**
   * Get chat history
   * @param {number} limit - Maximum number of messages
   * @returns {Promise<array>} Chat history
   */
  async getHistory(limit = 50) {
    try {
      const response = await fetch(`/api/chat/history?limit=${limit}`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return [];
      }
      
      const data = await response.json();
      return data.messages || [];
    } catch (error) {
      console.error('[ChatAPI] Error fetching history:', error);
      return [];
    }
  }
}
